import { render, staticRenderFns } from "./reminder-table-component.vue?vue&type=template&id=c2c76450&scoped=true&lang=pug"
import script from "./reminder-table-component.js?vue&type=script&lang=js&external"
export * from "./reminder-table-component.js?vue&type=script&lang=js&external"
import style0 from "./reminder-table-component.vue?vue&type=style&index=0&id=c2c76450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c76450",
  null
  
)

export default component.exports